import React, { Component } from 'react';
import './notice-item.less';
import styles from './notice-item.less';
import Button from '@tencent/dui/lib/components/Button';
import * as Images from './images'

export default class NoticeItem extends Component {
	constructor(props) {
		super(props);
	}
	onClose(ev) {
		this.props.onClose && this.props.onClose(ev);
	}
	onJoin(ev) {
		window.open(this.props.data.url);
		this.props.onClose && this.props.onClose(ev);
	}
	render() {
		let style = (name) => {
			return styles[name] || name;
		}
		let { name, startTime, url, userPic } = this.props.data;
		return <div className={style('item_wrapper')} key={url}>
			<Button
				className={style('modal-close')}
				onClick={this.onClose.bind(this)}>
				<span className={style('modal-close-x')}></span>
			</Button>
			<div className={style('tip')}>
				<div className={style('pic_wrapper')}>
					<img className={style('pic')}
						src={userPic||''}
						ref={img => { this.userImg = img }}
						onError={ev => { this.userImg.src = Images.AUDIENCE }}
					></img>
				</div>
				<span className={style('name')}>{name}</span>
				<div className={style('tip_text')}>
					发起远程演示
				</div>
				<div className={style('time')}>{startTime}</div>
			</div>
			<div className={style('splite')}>
				<div className={style('line')}></div>
			</div>
			<div className={style('link_wrapper')}
				
			>
				<a
					// href={url}
					className={style('link')}
					target='black'
					onClick={this.onJoin.bind(this)}>
					立即加入
				</a>
			</div>
		</div>
	}
}